<template :key="componentKey">

    <header id="appbar" v-cloak data-role="appbar" class="w-100 bg-transparent" :class="{ 'appbar-full-width': !user }" data-expand-point="xl">

        <div class="app-bar-container bg-white w-100 d-flex flex-justify-center" style="user-select: none;">
            <!--<div>                
                <router-link to="/dashboard">
                    <img src="/assets/img/brand/iperius_one_complete_logo_black.svg" height="100" alt="Iperius One" class="mt-7 ml-7">
                </router-link>
            </div>-->
            <div v-if="!$root.siteURL.contains('/one.iperius.com')" class="w-50 d-flex flex-justify-between flex-align-center ml-20 h4">
                <span><b>ONE URL</b> : <span>{{ $root.siteURL }}</span></span>
                <span :class="$root.serverURL.contains('eu-rs2.iperius.com') ? 'fg-red' : ''"><b>SERVER</b> : <span>{{ $root.serverURL }}</span></span>
            </div>
            <div class="d-flex flex-align-center ml-auto">
                <ul class="bg-transparent h-menu d-flex mr-2">
                    <li class="notification-item" ref="notificationItem">
                        <a href="#" class="app-bar-item notification-button" :title="$t('Notifications')" :aria-expanded="showNotifications ? 'true' : 'false'" aria-haspopup="true" @click.prevent.stop="toggleNotifications">
                            <span class="icon mif-notifications mif-2x"></span>
                            <span v-if="notifications.length" class="notification-badge bg-alert fg-white">
                                {{ notifications.length }}
                            </span>
                        </a>
                        <div v-if="showNotifications" class="notification-panel border shadow-2 bg-white" role="region" :aria-label="$t('Notifications')" @click.stop>
                            <div class="notification-header text-bold border-bottom">
                                {{ $t('Notifications') }}
                            </div>
                            <div v-if="notifications.length === 0" class="notification-empty fg-gray-600">
                                {{ $t('No notifications') }}
                            </div>
                            <div v-for="notification in notifications" :key="notification.id" :title="notification.message" class="notification-row border-bottom" :class="['notification-' + notification.level, { 'notification-highlighted': notification.id === highlightedNotificationId }]">
                                <span class="notification-level-dot"></span>
                                <span class="notification-message">{{ notification.message }}</span>
                                <span class="notification-time fg-gray-600">{{ formatNotificationTime(notification.createdAt) }}</span>
                            </div>
                        </div>
                    </li>

                    <template v-if="!user">
                        <li>
                            <a :href="pricingUrl" target="blank" class="button secondary app-bar-item" style="height:35px; margin-top:9px;" :title="$t('Buy an Iperius One License')">
                                <span class="icon mif-cart mr-2"></span>
                                <span class="menu-text">{{ $t("Buy an Iperius One License") }}</span>
                            </a>
                        </li>

                        <li>
                            <a :href="contactUrl" target="_blank" rel="noopener noreferrer" class="app-bar-item" :title="$t('Contact us')">
                                <span class="icon mif-phone mif-1x mr-2"></span>
                                <span class="menu-text">{{ $t('Contact us') }}</span>
                            </a>
                        </li>

                    </template>
                    <li class="ml-2 mr-2 hide-mobile agent-download-item" ref="agentDownloadItem" v-if="$root.authObj && !$root.authObj.licenceExpired">
                        <a href="#" ref="agentDownloadButton" class="button secondary app-bar-item" style="height:35px; margin-top:9px;" @click.prevent="toggleAgentBuilding" :title="$t('Agent download')" aria-label="Agent download">
                            <span class="icon mif-download"></span>
                            <span class="menu-text">{{ $t("Agent download") }}</span>
                        </a>
                        <div v-if="showAgentLicenseHint" class="agent-license-hint border shadow-2 bg-white" role="dialog" aria-live="polite" @click.stop>
                            <div class="d-flex">
                                <div class="agent-license-hint-icon bg-light mr-3">
                                    <span class="mif-lock mif-2x fg-primary"></span>
                                </div>
                                <div>
                                    <div class="text-bold mb-1">{{ $t('Iperius ONE required') }}</div>
                                    <div class="text-small fg-gray-700">{{ noIperiusOneLicenseMessage }}</div>
                                </div>
                            </div>
                            <div class="d-flex flex-justify-end flex-align-center mt-4">
                                <button class="button mr-2" @click="hideIperiusOneLicenseHint">{{ $t('Close') }}</button>
                                <a class="button secondary" :href="$root.ecommerceUpgradeUrl" target="_blank" rel="noopener" @click="hideIperiusOneLicenseHint">
                                    {{ $t('Upgrade your license') }}
                                </a>
                            </div>
                        </div>
                    </li>
                    <li v-if="$root.authObj && user && $root.authObj.licenceExpired">
                        <a href="#" class="dropdown-toggle app-bar-item">
                            <span class="mif-account_circle mif-2x"></span>
                            <label class="pl-4 user-label">{{ $root.authObj.username }}</label>
                        </a>
                        <ul class="d-menu border w-100 bg-white" id="userdropdown" data-role="dropdown" style="z-index: 20000;">
                            <li class="bg-light">
                                <span class="pl-5">
                                    <span class="mif-user va-middle mif-2x"></span>
                                    &nbsp;&nbsp;
                                    <span class="menu-text va-middle">{{ $root.authObj.username }}</span>
                                </span>
                            </li>
                            <li>
                                <a @click="$parent.$parent.logout()" class="pl-5" :title="$t('Logout')">
                                    <span class="mif-exit va-middle mif-2x"></span>
                                    &nbsp;&nbsp;
                                    <span class="menu-text va-middle">
                                        {{ $t('Logout') }}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li v-else-if="$root.authObj && user">
                        <a href="#" class="dropdown-toggle app-bar-item">
                            <span class="mif-account_circle mif-2x"></span>
                            <label class="pl-4 user-label">{{ $root.authObj.firstname + ' ' + $root.authObj.lastname + ' (' + $root.authObj.username + ')' }}</label>
                        </a>
                        <ul class="d-menu border w-100 bg-white" id="userdropdown" data-role="dropdown" style="z-index: 20000;">
                            <!-- Profilo utente -->
                            <li class="bg-light ">
                                <router-link :to="'/users#' + $root.authObj.id_user" class="pl-5 " :title="$t('User Profile')">
                                    <span class="mif-user va-middle mif-2x"></span>
                                    &nbsp;&nbsp;
                                    <span class="menu-text va-middle">
                                        {{ $t('User Profile') }}
                                    </span>
                                    &nbsp;
                                    <span class="badge bg-primary fg-white inline menu-text va-middle">
                                        {{ $root.authObj.roles }}
                                    </span>
                                </router-link>
                            </li>

                            <!-- Licenza -->
                            <li>
                                <router-link to="/licenses" class="pl-5" :title="$t('License')">
                                    <span class="mif-security va-middle mif-2x"></span>
                                    &nbsp;&nbsp;
                                    <span class="menu-text va-middle">
                                        {{ $t('License') }}
                                    </span>
                                </router-link>
                            </li>

                            <!-- Esporta log -->
                            <li>
                                <a class="pl-5" href="#" @click="$root.$emit('OPENEXPORTLOGSDIALOG')" :title="$t('Export logs')">
                                    <span class="mif-download2 va-middle mif-2x"></span>
                                    &nbsp;&nbsp;
                                    <span class="menu-text va-middle">
                                        {{ $t('Export logs') }}
                                    </span>
                                </a>
                            </li>

                            <!-- Logout -->
                            <li>
                                <a @click="$parent.$parent.logout()" class="pl-5" :title="$t('Logout')">
                                    <span class="mif-exit va-middle mif-2x"></span>
                                    &nbsp;&nbsp;
                                    <span class="menu-text va-middle">
                                        {{ $t('Logout') }}
                                    </span>
                                </a>
                            </li>
                        </ul>


                    </li>

                </ul>
            </div>
            <div class="mr-2"><locale-changer /></div>

        </div>
    </header>

</template>

<script>
import LocaleChangerVue from '../components/LocaleChanger.vue';

export default {
    name: 'Appbar',
    components: {
        'locale-changer': LocaleChangerVue,
    },
    props: {
        user: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            componentKey: 0,
            events: [],
            showNotifications: false,
            notificationsCloseTimer: null,
            notificationHighlightTimer: null,
            highlightedNotificationId: null,
            showAgentLicenseHint: false,
            contactUrl: process.env.VUE_APP_ECOMM_SITE_URL + 'en/contact/',
            pricingUrl: process.env.VUE_APP_ECOMM_SITE_URL + 'en/pricing/'
        };
    },
    computed: {
        notifications() {
            return this.$root.notifications || [];
        },
        noIperiusOneLicenseMessage() {
            return this.$t('Your license does not include Iperius ONE features; it only includes an Iperius Remote license. To generate and install the Iperius ONE agent, upgrade to Iperius ONE.');
        }
    },
    methods: {
        toggleNotifications() {
            if (this.showNotifications) {
                this.hideNotifications();
                return;
            }
            this.showNotificationsPanel(false);
        },
        showNotificationsPanel(notification = null) {
            const autoClose = notification && typeof notification === 'object';
            this.showNotifications = true;
            clearTimeout(this.notificationHighlightTimer);
            this.highlightedNotificationId = autoClose ? notification.id : null;
            if (autoClose) {
                this.notificationHighlightTimer = setTimeout(() => {
                    this.highlightedNotificationId = null;
                }, 2500);
            }
            clearTimeout(this.notificationsCloseTimer);
            this.notificationsCloseTimer = null;
            if (autoClose) {
                this.notificationsCloseTimer = setTimeout(() => {
                    this.hideNotifications();
                }, 5000);
            }
            this.$nextTick(() => {
                document.addEventListener('click', this.handleNotificationsOutsideClick);
                document.addEventListener('keydown', this.handleNotificationsKeydown);
            });
        },
        hideNotifications() {
            this.showNotifications = false;
            clearTimeout(this.notificationsCloseTimer);
            this.notificationsCloseTimer = null;
            clearTimeout(this.notificationHighlightTimer);
            this.notificationHighlightTimer = null;
            this.highlightedNotificationId = null;
            document.removeEventListener('click', this.handleNotificationsOutsideClick);
            document.removeEventListener('keydown', this.handleNotificationsKeydown);
        },
        handleNotificationsOutsideClick(event) {
            if (!this.$refs.notificationItem || !this.$refs.notificationItem.contains(event.target)) {
                this.hideNotifications();
            }
        },
        handleNotificationsKeydown(event) {
            if (event.key === 'Escape') this.hideNotifications();
        },
        formatNotificationTime(value) {
            return new Intl.DateTimeFormat(this.$i18n.locale, {
                hour: '2-digit',
                minute: '2-digit'
            }).format(new Date(value));
        },
        forceRerender() {
            this.componentKey += 1;
        },
        toggleAgentBuilding(event) {
            if (this.$root.noIperiusOneLicense) {
                this.showIperiusOneLicenseHint(event);
                return;
            }

            // Assicurati che il charms esista nel DOM
            const el = document.querySelector('#agentbuilding');
            if (!el || !window.Metro) return;

            // Inizializza il plugin se non lo è già (più robusto di usare window.Metro.charms)
            let charms = Metro.getPlugin(el, 'charms');
            if (!charms) {
                // inizializza solo il nodo/contesto necessario
                try { Metro.init(el); } catch (e) { }
                charms = Metro.getPlugin(el, 'charms');
            }

            if (charms && typeof charms.toggle === 'function') {
                charms.toggle();
            } else {
                console.warn('Charms non disponibile su #agentbuilding');
            }
        },
        showIperiusOneLicenseHint(event) {
            event?.stopPropagation?.();
            this.showAgentLicenseHint = true;
            this.$root.refreshEcommerceUpgradeUrl();

            this.$nextTick(() => {
                document.addEventListener('click', this.handleAgentLicenseHintOutsideClick);
                document.addEventListener('keydown', this.handleAgentLicenseHintKeydown);
            });
        },
        hideIperiusOneLicenseHint() {
            this.showAgentLicenseHint = false;
            document.removeEventListener('click', this.handleAgentLicenseHintOutsideClick);
            document.removeEventListener('keydown', this.handleAgentLicenseHintKeydown);
        },
        handleAgentLicenseHintOutsideClick(event) {
            if (!this.$refs.agentDownloadItem || !this.$refs.agentDownloadItem.contains(event.target)) {
                this.hideIperiusOneLicenseHint();
            }
        },
        handleAgentLicenseHintKeydown(event) {
            if (event.key === 'Escape') {
                this.hideIperiusOneLicenseHint();
            }
        }
    },
    mounted() {
        this.$root.$on('NEWNOTIFICATION', this.showNotificationsPanel);

    },
    beforeDestroy() {
        this.$root.$off('NEWNOTIFICATION', this.showNotificationsPanel);
        this.hideNotifications();
        this.hideIperiusOneLicenseHint();
    },
}
</script>

<style scoped>
.notification-item {
    position: relative;
}

.notification-button {
    position: relative;
}

.notification-badge {
    position: absolute;
    top: 5px;
    right: 4px;
    min-width: 18px;
    border-radius: 9px;
    font-size: 11px;
    text-align: center;
}

.notification-panel {
    position: absolute;
    top: 52px;
    right: 0;
    z-index: 20050;
    width: 320px;
    max-width: calc(100vw - 24px);
    border-radius: 8px;
    overflow: hidden;
}


.notification-header,
.notification-empty {
    padding: 10px 12px;
}

.notification-row {
    display: grid;
    grid-template-columns: 9px minmax(0, 1fr) auto;
    align-items: start;
    gap: 8px;
    padding: 9px 12px;
    transition: background-color .3s ease, box-shadow .3s ease;
}

.notification-highlighted {
    background-color: #eaf5ff;
    box-shadow: inset 3px 0 0 #0366d6;
    animation: notification-highlight 1s ease-in-out 2;
}

@keyframes notification-highlight {

    0%,
    100% {
        background-color: #eaf5ff;
    }

    50% {
        background-color: #cfe9ff;
    }
}

.notification-row:last-child {
    border-bottom: 0 !important;
}

.notification-level-dot {
    display: block;
    width: 9px;
    height: 9px;
    margin-top: 4px;
    border-radius: 50%;
    background: #5ebdec;
}

.notification-success .notification-level-dot,
.notification-ok .notification-level-dot {
    background: #60a917;
}

.notification-alert .notification-level-dot,
.notification-error .notification-level-dot {
    background: #ce352c;
}

.notification-warning .notification-level-dot {
    background: #f0a30a;
}

.notification-message {
    min-width: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    line-height: 1.3;
}

.notification-time {
    white-space: nowrap;
    line-height: 1.3;
    font-size: 11px;
}

.agent-download-item {
    position: relative;
}

.agent-license-hint {
    position: absolute;
    top: 52px;
    right: 0;
    z-index: 20050;
    width: 360px;
    max-width: calc(100vw - 24px);
    padding: 16px;
    border-radius: 8px;
    line-height: 1.35;
}

.agent-license-hint::before {
    content: "";
    position: absolute;
    top: -8px;
    right: 42px;
    width: 14px;
    height: 14px;
    background: #fff;
    border-left: 1px solid #dfdfdf;
    border-top: 1px solid #dfdfdf;
    transform: rotate(45deg);
}

.agent-license-hint-icon {
    width: 42px;
    height: 42px;
    min-width: 42px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
